import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsersInclusive } from '../../../../reducers/users';
import { getInvites } from '../../../../reducers/invites';
import Tabs from '../../../../components/tabs';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import UsersList from '../../lists/users';
import InvitesList from '../../lists/invites';

class ClientUsers extends React.Component {
    componentDidMount() {
        const { role, users, invites, getUsersInclusive, getInvites } = this.props;
        if (!users) getUsersInclusive(role, undefined);
        if (!invites) getInvites(role);
    }

    render() {
        const { users, invites, role, client, page } = this.props;
        if (!users && !invites) {
            return null;
        }

        const items = [
            { title: <FormattedMessage {...messages.users} />, content: <UsersList users={users} role={role} /> },
            {
                title: <FormattedMessage {...messages.invites} />,
                content: <InvitesList invites={invites} role={role} client={client} />
            }
        ];

        return <Tabs items={items} pageWide title={page.label} isPageTitle={true} />;
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    client: state.identity.details,
    users: state.users.list,
    invites: state.invites.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getUsersInclusive: getUsersInclusive,
            getInvites: getInvites
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientUsers);



// WEBPACK FOOTER //
// ./src/pages/users/tenants/client/index.jsx